import { ReactNode } from 'react';

import { useDraggable } from '@dnd-kit/core';

import { IncubatorMapSlot } from '@/app/services/fertWork';

export type DraggableSlotProps = {
  id: string;
  slot: IncubatorMapSlot;
  children: ReactNode;
  dataTour?: string;
};

export const DraggableSlot = ({
  id,
  slot,
  children,
  dataTour,
}: DraggableSlotProps) => {
  const { attributes, listeners, setNodeRef, isDragging } = useDraggable({
    id,
    data: { slot },
  });

  return (
    <div
      ref={setNodeRef}
      className={`group relative ${isDragging ? 'z-50 opacity-50' : ''}`}
    >
      <div
        {...listeners}
        {...attributes}
        data-tour={dataTour}
        className="absolute inset-y-0 left-0 z-10 flex w-4 cursor-grab touch-none items-center justify-center rounded-l-lg border-r border-gray-200 bg-gray-100 transition-colors hover:bg-gray-200"
      >
        <div className="flex flex-col gap-[3px]">
          <div className="flex gap-[3px]">
            <div className="h-1 w-1 rounded-full bg-gray-400" />
            <div className="h-1 w-1 rounded-full bg-gray-400" />
          </div>
          <div className="flex gap-[3px]">
            <div className="h-1 w-1 rounded-full bg-gray-400" />
            <div className="h-1 w-1 rounded-full bg-gray-400" />
          </div>
          <div className="flex gap-[3px]">
            <div className="h-1 w-1 rounded-full bg-gray-400" />
            <div className="h-1 w-1 rounded-full bg-gray-400" />
          </div>
        </div>
      </div>
      {children}
    </div>
  );
};
